import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d991780c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Detalles del artículo", -1))
const _hoisted_3 = { class: "Tbody" }
const _hoisted_4 = { class: "img-book" }
const _hoisted_5 = ["src", "width", "height"]
const _hoisted_6 = { class: "details" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Categoría:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Empresa:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Producto:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Descripción del producto:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Precio:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn-download" }, "Comprar")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Recuerda que comprando a través de los enlaces de Ademass estas contribuyendo al mantenimiento de la plataforma.", -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import Navbar from '@/components/layouts/NavBar.vue';
import { Ref, ref, onMounted } from 'vue';
import ShopService from '@/services/ShopService'
import { useRoute } from 'vue-router';
import ShopInterface from '@/interfaces/ShopInterface';
import main from '@/data/main.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShopDetailView',
  setup(__props) {

const route = useRoute()
const loading: Ref<boolean> = ref(false)
const service = new ShopService()
const category = ref([])
const featuresCategory = ref([])
const features: Ref<ShopInterface> = ref({})
const widthIMG: Ref<number> = ref(600)
const heightIMG: Ref<number> = ref(400)


onMounted(async () => {
    try {
        loading.value = true;
        category.value = await service.ListAllCategories();
        features.value = await service.GetDetailItem(route.params.id);
        featuresCategory.value = await service.ListAllItemsFromCategory(route.params.id);
    } catch (error) {
        console.error('Error al cargar detalles del ítem:', error);
    } finally {
        loading.value = false;
    }
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(Navbar),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _unref(main).SHOP_DETAIL_VIEW,
              alt: "img prueba",
              width: `${widthIMG.value}`,
              height: `${heightIMG.value}`,
              style: {"border-radius":"8px"}
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _hoisted_7,
              _createElementVNode("p", null, _toDisplayString(features.value.category?.name), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_8,
              _createElementVNode("p", null, _toDisplayString(features.value?.publisher), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_9,
              _createElementVNode("p", null, _toDisplayString(features.value?.title), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_10,
              _createElementVNode("p", null, _toDisplayString(features.value?.description), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_11,
              _createElementVNode("p", null, _toDisplayString(features.value?.price) + "€", 1)
            ]),
            _hoisted_12,
            _hoisted_13
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})